'use client';
import React, { useState } from 'react';
import { Shield, X, Phone } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

export default function RwandaComplianceBanner() {
  const [dismissed, setDismissed] = useState(false);
  const { t } = useLanguage();

  if (dismissed) return null;

  return (
    <div
      className="relative rounded-xl px-4 py-3 flex items-start gap-3 overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, rgba(0,51,153,0.06) 0%, rgba(227,174,84,0.08) 100%)',
        border: '1px solid rgba(0,51,153,0.15)',
      }}
    >
      {/* Decorative accent */}
      <div className="absolute top-0 left-0 w-1 h-full rounded-l-xl" style={{ background: 'linear-gradient(180deg, #003399, #E3AE54)' }} />

      <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ml-1" style={{ background: 'rgba(0,51,153,0.1)' }}>
        <Shield size={16} style={{ color: '#003399' }} />
      </div>

      <div className="flex-1 min-w-0">
        <p className="text-xs font-700 text-foreground">{t('compliance.title')}</p>
        <p className="text-xs text-muted-foreground mt-0.5 leading-relaxed">{t('compliance.body')}</p>
        <div className="flex items-center gap-3 mt-2">
          <a
            href="tel:3029"
            className="inline-flex items-center gap-1.5 text-xs font-600 px-2.5 py-1 rounded-full transition-colors"
            style={{ background: 'rgba(0,51,153,0.1)', color: '#003399' }}
          >
            <Phone size={11} />
            Umubano: 3029
          </a>
          <span className="text-xs text-muted-foreground">RDB · NLGC Licensed</span>
        </div>
      </div>

      <button
        onClick={() => setDismissed(true)}
        className="p-1 rounded-md transition-colors flex-shrink-0"
        style={{ color: 'rgba(0,0,0,0.35)' }}
        aria-label="Dismiss"
      >
        <X size={14} />
      </button>
    </div>
  );
}
